export const FACR_CLUB_ID = process.env.REACT_APP_FACR_CLUB_ID || '';
export const FACR_CLUB_TYPE: 'football' | 'futsal' = (process.env.REACT_APP_FACR_CLUB_TYPE as any) || 'football';

export const isFacrConfigured = (): boolean => !!FACR_CLUB_ID;
